<div class="h-full w-full flex flex-col overflow-hidden">
  <div class="h-full w-full flex flex-col items-center justify-center">
    <h2
      class="text-2xl font-semibold tracking-tight text-balance text-primary sm:text-4xl md:text-5xl text-center">
      Start <span class="bg-linear-to-r from-primary to-brand-studio bg-clip-text text-transparent">monitoring</span> by selecting your spec creation flow.
    </h2>
    <p class="mx-auto mt-2 max-w-2xl text-base sm:text-lg/8 text-pretty text-secondary text-center">
      The same brief, two flows — pick how you want to work. Let our AI draft the whole thing or follow a guided
      wizard step by step.</p>

    <div class="w-full max-w-4xl flex flex-col gap-y-2 py-6 sm:py-8">
      <div class="w-full grid grid-cols-1 sm:grid-cols-2 gap-6">

        <article (click)="choose.emit('ai')" data-guide-id="monitoring.chooseAi"
          class="flex flex-col group overflow-hidden rounded-xl border border-gray-200 dark:border-white/10 gap-y-2 hover:border-fuchsia-500 dark:hover:border-fuchsia-400 cursor-pointer shadow-md group-hover:shadow-lg transition-all duration-300">
          <div class="w-full p-4 group-hover:p-2 transition-all duration-300">
            <img src="/assets/images/01-ai-first-brief.png" class="block w-full h-auto object-contain" alt="">
          </div>
          <div class="p-4 flex flex-col h-full justify-between">
            <div class="flex-1 flex flex-col">
              <p
                class="inline-flex w-fit self-start items-center gap-x-1.5 rounded-full bg-fuchsia-100 px-2 py-1 text-xs font-medium text-fuchsia-500 dark:bg-fuchsia-400/10 dark:text-fuchsia-400">
                SHOUT AI
              </p>
              <h3
                class="mt-2 text-2xl font-semibold tracking-tight text-pretty text-gray-900 sm:text-4xl dark:text-white group-hover:text-fuchsia-500 transition-all duration-300">
                AI-First</h3>
              <p class="mt-6 text-sm text-primary">Describe what you want to watch in a sentence.
                SHOUT AI drafts the brief — you review and refine.</p>
            </div>
            <div class="shrink-0 flex flex-row items-center justify-between pt-4">
              <p class="font-medium whitespace-nowrap text-fuchsia-500 dark:text-fuchsia-300">
                Start with AI
                <span aria-hidden="true"> &rarr;</span>
              </p>
              <p class="text-xs text-secondary">~2 min</p>
            </div>
          </div>
        </article>

        <article (click)="choose.emit('wizard')" data-guide-id="monitoring.chooseWizard"
          class="flex flex-col group overflow-hidden rounded-xl border border-gray-200 dark:border-white/10 gap-y-2 hover:border-fuchsia-500 dark:hover:border-fuchsia-400 cursor-pointer shadow-md group-hover:shadow-lg transition-all duration-300">
          <div class="w-full p-4 group-hover:p-2 transition-all duration-300">
            <img src="/assets/images/02-guided-wizard-screening.png" class="block w-full h-auto object-contain" alt="">
          </div>
          <div class="p-4 flex flex-col h-full justify-between">
            <div class="flex-1 flex flex-col">
              <p
                class="inline-flex w-fit self-start items-center gap-x-1.5 rounded-full bg-fuchsia-100 px-2 py-1 text-xs font-medium text-fuchsia-500 dark:bg-fuchsia-400/10 dark:text-fuchsia-400">
                Guided
              </p>
              <h3
                class="mt-2 text-2xl font-semibold tracking-tight text-pretty text-gray-900 sm:text-4xl dark:text-white group-hover:text-fuchsia-500 transition-all duration-300">
                Guided Wizard</h3>
              <p class="mt-6 text-sm text-primary">One decision at a time. Walk through the product, what to watch
                for, the monitoring window, and who to include before launch.</p>
            </div>
            <div class="shrink-0 flex flex-row items-center justify-between pt-4">
              <p class="font-medium whitespace-nowrap text-fuchsia-500 dark:text-fuchsia-300">
                Open Wizard
                <span aria-hidden="true"> &rarr;</span>
              </p>
              <p class="text-xs text-secondary">6 steps</p>
            </div>
          </div>
        </article>

      </div>
    </div>
  </div>
</div>
